/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x3049=['numeric','toLocaleTimeString'];(function(_0x478eda,_0x304958){var _0x39f27a=function(_0x2e5de2){while(--_0x2e5de2){_0x478eda['push'](_0x478eda['shift']());}};_0x39f27a(++_0x304958);}(_0x3049,0x76));var _0x39f2=function(_0x478eda,_0x304958){_0x478eda=_0x478eda-0x0;var _0x39f27a=_0x3049[_0x478eda];return _0x39f27a;};export function dateToPrettyFormat(_0x1a1894,_0x1056a8){return _0x1056a8['toLocaleDateString'](_0x1a1894,{'month':'long','day':_0x39f2('0x0')})+',\x20'+_0x1056a8[_0x39f2('0x1')](_0x1a1894,{'hour':'numeric','minute':'numeric'});}